import { CoObjectItem } from "../components/interfaces/CoObject";
import { createContentControlForCoObject } from "./ContentControl";
import { ContentControlCreationError, InsertionLocationNotAllowedError } from "./ContentControlErrors";
import { getContentControlById } from "./WordDocumentPart";

export function insertFreeText(coObject: CoObjectItem): Promise<Word.ContentControl> {
  return Word.run(async (context) => {
    const cc = await createContentControlForCoObject(coObject, false);
    const wordContentControl = await getContentControlById(context, cc.id);
    if (!wordContentControl) {
      throw new ContentControlCreationError(
        new Error(`No content control found in the document for id ${cc.id}`),
        cc.id,
        false
      );
    }

    wordContentControl.insertText("", "Start");
    await context.sync();
    return wordContentControl;
  }).catch((error) => {
    console.error(error);
    if (error instanceof ContentControlCreationError || error instanceof InsertionLocationNotAllowedError) {
      throw error;
    }
    throw new ContentControlCreationError(error, undefined, false);
  });
}
